"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var accessory_service_1 = require("../../../shared/service/accessory.service");
var accessory_amount_service_1 = require("../../../shared/service/accessory-amount.service");
var toast_service_1 = require("../../../shared/service/toast.service");
var accessory_amount_1 = require("../../../shared/model/accessory-amount");
var router_1 = require("@angular/router");
var AccessoryCreateComponent = /** @class */ (function () {
    function AccessoryCreateComponent(_accessoryService, _accessoryAmountService, _toastService, _router) {
        this._accessoryService = _accessoryService;
        this._accessoryAmountService = _accessoryAmountService;
        this._toastService = _toastService;
        this._router = _router;
        this.accessoryAttributesTree = ['name'];
    }
    AccessoryCreateComponent.prototype.ngOnInit = function () {
        this.setUpEmptyEntities();
        this.findAccessories();
    };
    AccessoryCreateComponent.prototype.selectAccessory = function (accessory) {
        if (this.selectedAccessory === accessory) {
            this.selectedAccessory = null;
        }
        else {
            this.selectedAccessory = accessory;
        }
    };
    AccessoryCreateComponent.prototype.save = function () {
        if (this.quantity && this.selectedAccessory) {
            this._accessoryAmountService.save(new accessory_amount_1.AccessoryAmount(null, this.quantity, null, this.selectedAccessory));
            this.cleanEntities();
        }
    };
    AccessoryCreateComponent.prototype.goBack = function () {
        this._router.navigate(['accessories']);
    };
    AccessoryCreateComponent.prototype.setUpEmptyEntities = function () {
        this.accessories = new Array();
        this.quantity = null;
    };
    AccessoryCreateComponent.prototype.findAccessories = function () {
        var _this = this;
        this._accessoryService.getAccessoryTypes()
            .subscribe(function (accessories) { return _this.accessories = accessories; }, function (error) { return _this.showMessage(error.text); });
    };
    AccessoryCreateComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    AccessoryCreateComponent.prototype.cleanEntities = function () {
        this.selectedAccessory = null;
        this.quantity = null;
    };
    AccessoryCreateComponent.ctorParameters = function () { return [{ type: accessory_service_1.AccessoryService }, { type: accessory_amount_service_1.AccessoryAmountService }, { type: toast_service_1.ToastService }, { type: router_1.Router }]; };
    return AccessoryCreateComponent;
}());
exports.AccessoryCreateComponent = AccessoryCreateComponent;
//# sourceMappingURL=accessory-create.component.js.map


// WEBPACK FOOTER //
// accessory-create.component.js